import { createForm } from '../../../factories'

export default createForm(['name', 'description'])



// WEBPACK FOOTER //
// ./src/store/modules/topics/forms/store.js